import { COLORS } from "../../../../../../users/data";
import { createDefaultDepartment, DepartmentFormValues } from "../../../types";

const manualDepartmentPresets: Array<
  Partial<Omit<DepartmentFormValues, "id">>
> = [
  { color: COLORS[11].color },
  { color: COLORS[4].color },
  { color: COLORS[1].color },
];

const templateDepartmentPresets: Array<
  Partial<Omit<DepartmentFormValues, "id">>
> = [
  { name: "הנהלה", icon: "icon8", color: COLORS[11].color },
  { name: "מטבח", icon: "icon5", color: COLORS[4].color },
  { name: "מסעדה", icon: "icon11", color: COLORS[1].color },
  { name: "בר", icon: "icon10", color: COLORS[3].color },
  { name: "אדמיניסטרציה", icon: "icon8", color: COLORS[10].color },
  { name: "מאפיה", icon: "icon12", color: COLORS[9].color },
  { name: "קונדיטוריה", icon: "icon18", color: COLORS[5].color },
];

const templateOrgDepartmentPresets: Array<
  Partial<Omit<DepartmentFormValues, "id">>
> = [
  { name: "הנהלה", icon: "icon8", color: COLORS[11].color },
  { name: "כספים", icon: "icon27", color: COLORS[4].color },
  { name: "משפטית", icon: "icon24", color: COLORS[1].color },
  { name: "לוגיסטיקה", icon: "icon28", color: COLORS[3].color },
  { name: "משאבי אנוש", icon: "icon29", color: COLORS[10].color },
  { name: "תחבורה", icon: "icon30", color: COLORS[9].color },
  { name: "ביטחון", icon: "icon31", color: COLORS[5].color },
];

const buildDepartments = (
  presets: Array<Partial<Omit<DepartmentFormValues, "id">>>,
) => presets.map((preset) => createDefaultDepartment(preset));

export const getManualDepartments = () =>
  buildDepartments(manualDepartmentPresets);

export const getTemplateOrgDepartments = () =>
  buildDepartments(templateOrgDepartmentPresets);

export const getTemplateDepartments = () =>
  buildDepartments(templateDepartmentPresets);